import React, { SFC, ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { forDesktop, forIE, forTablet } from '@westwing/ui-kit/breakPoints';
import { StyledArrowIcon } from '@westwing/ui-kit/Icons/StyledIcons';
import HybridLink from '../Generic/Links/HybridLink';

const StyledLink = styled(HybridLink)`
    display: block;
    width: 100%;
    height: 100%;
    line-height: 26px;
`;

const StyledWrapper = styled.div<{ p100CategoryBubblesDisabledDesktop?: boolean }>`
    grid-area: back;
    margin-left: 20px;
    display: block;
    width: 30px;
    height: 30px;
    padding: 0 5px;
    text-align: left;

    ${forTablet`
    margin: 3px 0 0;
`}
    ${forDesktop`
        margin: 17px 0 0;
    `}

    ${({ p100CategoryBubblesDisabledDesktop }) =>
        p100CategoryBubblesDisabledDesktop &&
        css`
            ${forDesktop`
                display: none;
            `}
        `}
 

    ${forIE`
    -ms-grid-row: 2;
    -ms-grid-column: 1;
`}
`;

export interface GoBackLinkProps {
    to: string;
    isRoot: boolean;
    p100CategoryBubblesDisabledDesktop?: boolean;
}

const BackButton: SFC<GoBackLinkProps> = ({ to, isRoot, p100CategoryBubblesDisabledDesktop }): ReactElement | null =>
    isRoot ? null : (
        <StyledWrapper p100CategoryBubblesDisabledDesktop={p100CategoryBubblesDisabledDesktop}>
            <StyledLink to={to}>
                <StyledArrowIcon size={9} />
            </StyledLink>
        </StyledWrapper>
    );
export default BackButton;
